import { useSelector, useDispatch } from "react-redux";
import {
  TRACK_CONVERSATION_SENT,
  TRACK_ATTACH_DOCUMENTS_CLICKED_COMPOSE_EVENT,
  TRACK_INSERT_WIDGET_CLICKED_COMPOSE_EVENT,
  TRACK_SELECT_TEMPLATE_CLICKED_COMPOSE_EVENT,
  TRACK_TEMPLATE_SELECTED_EVENT,
  TRACK_RECOMMENDED_ASSET_CLICKED,
  TRACK_WIDGET_INSERTED_COMPOSE_EVENT,
} from "src/constants/adoption/eventTypes";
import { trackEventForAdoption } from "../adoption";
import {
  ConversationSent,
  SelectedTemplate,
  widgetInserted,
} from "src/types/adoption/compose";
import { COMPOSE } from "src/constants/adoption/sourceTypes";

export const useComposeAdoption = () => {
  const dispatch = useDispatch();


 // compose email send
  const trackConversationSent = ({sourceCta, collectionName, assetType, templateSelected, is_widgetInserted, isAssetsShared, isCollectionShared, recommendedAsset}: ConversationSent) => {

    const event = {
      event: TRACK_CONVERSATION_SENT,
      properties: {
        source_cta: sourceCta,
        collection_name: collectionName,
        asset_type: assetType,
        isTemplateSelected: templateSelected,
        iswidgetInserted: is_widgetInserted,
        isAttachedAsset: isAssetsShared,
        isAttachedCollection: isCollectionShared,
        isRecommended: recommendedAsset,
      },
    };
    dispatch(trackEventForAdoption(event));
  };

  // add assets clicked in compose

  const trackAttachDocumentsClicked = () => {
    const sourceCta = COMPOSE;

    const event = {
      event: TRACK_ATTACH_DOCUMENTS_CLICKED_COMPOSE_EVENT,
      properties: {
        source_cta: sourceCta,
      },
    };
    dispatch(trackEventForAdoption(event));
  };

  // add widgets clicked in compose

  const trackWidgetsClicked = () => {
    const sourceCta = COMPOSE;

    const event = {
      event: TRACK_INSERT_WIDGET_CLICKED_COMPOSE_EVENT,
      properties: {
        source_cta: sourceCta,
      },
    };
    dispatch(trackEventForAdoption(event));
  };

  // add templates clicked in compose

  const trackTemplatesClicked = () => {
    const sourceCta = COMPOSE;

    const event = {
      event: TRACK_SELECT_TEMPLATE_CLICKED_COMPOSE_EVENT,
      properties: {
        source_cta: sourceCta,
      },
    };
    dispatch(trackEventForAdoption(event));
  };

  //selected template 

  const trackSelectedTemplateClicked = ({ templateName }: SelectedTemplate) => {
    const sourceCta = COMPOSE;

    const event = {
      event: TRACK_TEMPLATE_SELECTED_EVENT,
      properties: {
        source_cta: sourceCta,
        template_name: templateName,
      },
    };
    dispatch(trackEventForAdoption(event));
  };

  // recommened Asset Clicked
  const trackRecommenedAssetClicked = () => {
    const sourceCta = COMPOSE;

    const event = {
      event: TRACK_RECOMMENDED_ASSET_CLICKED,
      properties: {
        source_cta: sourceCta,
      },
    };
    dispatch(trackEventForAdoption(event));
  };

  // widgets inserted
  const trackWidgetInserted = ({ widgetType }: widgetInserted) => {
    const event = {
      event: TRACK_WIDGET_INSERTED_COMPOSE_EVENT,
      properties: {
        widget_type: widgetType,
      },
    };
    dispatch(trackEventForAdoption(event));
  };

  return {
    trackConversationSent,
    trackAttachDocumentsClicked,
    trackWidgetsClicked,
    trackTemplatesClicked,
    trackSelectedTemplateClicked,
    trackRecommenedAssetClicked,
    trackWidgetInserted,
  };
};
